import {
    Box,
    Typography,
    Grid,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Stack,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@mui/material";


export const DialogBox = ({open, setOpen, body, handleOK}) =>{
    return (
        <Dialog
                open={open}
                onClose={() => setOpen(!open)}
                maxWidth="sm"
                fullWidth
            >
                <DialogContent sx={{ pt: 3 }}>
                    <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', gap: '8px' }}>
                        {body}
                    </Stack>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button variant="outlined"  onClick={() => setOpen(!open)}>Close</Button>
                    <Button variant="contained"  onClick={() => {handleOK();setOpen(!open);}}>Ok</Button>
                </DialogActions>
            </Dialog>
    )
}

